import type { PriceTagScan } from '@recipes/contracts';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/** Follows one price tag scan until the photo was read (or could not be). */
export function useTagScan(scanId: string | null): PriceTagScan | null {
  const { data } = useQuery({
    queryKey: ['prices', 'tag-scan', scanId],
    queryFn: () => api.prices.scan(scanId!),
    enabled: Boolean(scanId),
    refetchInterval: (query) => (query.state.data?.status === 'PROCESSING' ? 1500 : false),
  });
  return scanId ? (data ?? null) : null;
}
